<template>
  <page>
    <template slot="content">
      <help-content :title="'歩数が0のまま同期できない(Android)'">
        <template slot="content">
          <div class="title">アクセス権限を許可</div>
          <div class="text p">
            WeRUNを初めて使う時に、各種アクセス権限を許可するダイアログが表示されたら、<b>すべて許可</b>してください。<br><br>
            許可しなかったまたは、ダイアログが表示されない場合は歩数が正しく計測されない可能性があります。スマホの<b>設定＞アプリと通知＞WeRUN＞権限</b>にて必要な権限をオンしてください。
          </div>
          <img class="picture" src="../assets/images/q_and_a/H3_0.png">
          <div class="title">センサーをテスト</div>
          <div class="text p">WeRUNはスマホの各種センサーを利用して計測しているため、センサーが正常に稼働していることを確認してください。WeRUNのメニュー＞設定＞センサーをテストにて画面ロックの状態で歩数計測のテストを行うことができます。詳しくは画面の指示に従って操作してください。
          </div>
          <img class="picture" src="../assets/images/q_and_a/H3.png">
          <div class="title">アプリを定期的に開く</div>
          <div class="text p">データの紛失を防ぐため、毎晩(または運動後に)アプリを開き、ホームを下スワイプしてデータの同期を行うことをおすすめします。<br>
          普段はバックグラウンドでアプリを実行し、電池の最適化しないように設定することによってプロセスの強制終了を防ぐことができます。<br>
          WeRUNでは<b>過去７日間のデータしか同期できない</b>ようになっています。７日間を超えてアプリを開いた場合は古いデータを紛失することがありますので、ご注意ください。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help3.vue